module.exports = __webpack_public_path__ + "img/banner2.77620e6c.jpg";